import anime from 'animejs';

let mainSlider = () => {

    let module = {},

        init = () => {
            if ($('.page404 .slider').length && $('#mobile').is(":hidden")) {

                // CSS Selectors
                let slideSwitcherSelector = '.slider__switcher';
                let slideSwitcherItemSelector = '.slider__switcher-';
                let svgSegmentSelector = '.slider__segment-xl-';

                let switcherAnimationDuration = 15000;

                // Get sliders and switchers
                let slideSwitchers = [...document.querySelectorAll(slideSwitcherSelector)];

                // If we have a third switch, we need to position it correctly
                let thirdSwitcher = document.querySelector('.slider__switcher-3');
                if (thirdSwitcher) {
                    thirdSwitcher.style.left = (0 - thirdSwitcher.offsetWidth - 17) + 'px';
                }

                for (let index = 0; index < slideSwitchers.length; index++) {
                //slideSwitchers.forEach(function (element, index) {
                    let element = slideSwitchers[index];
                    let path = anime.path(svgSegmentSelector + (index + 1));
                    let next_index = index + 1

                    if (slideSwitchers.length == next_index) {
                        next_index = 0;
                    }

                    anime({
                        targets: slideSwitcherItemSelector + (index + 1),
                        translateX: path('x'),
                        translateY: path('y'),
                        direction: 'alternate',
                        rotate: 0,
                        easing: 'cubicBezier(0.55, 0.005, 0.45, 0.995)',
                        duration: switcherAnimationDuration,
                        loop: true
                    });
                }
            }

        };

    module.init = init;

    return module;

};

export default mainSlider();
